import { useLanguage } from "@/context/LanguageContext";

/** Statuses that should show a public ribbon on cards / detail pages. */
export const RIBBON_STATUSES = ["sold", "reserved", "rented"];

/**
 * Diagonal corner ribbon for sold / reserved / rented properties.
 * Byron style: bronze (#C6A87C) band with white uppercase tracking.
 */
const PropertyStatusRibbon = ({ status, size = "default" }) => {
  const { t } = useLanguage();

  if (!status || !RIBBON_STATUSES.includes(status)) {
    return null;
  }

  const labelKey = `propertyStatus.${status}`;
  const label = t(labelKey);

  return (
    <div
      className={`property-status-ribbon property-status-ribbon--${size}`}
      data-testid={`property-status-ribbon-${status}`}
      aria-label={label}
    >
      <span>{label}</span>
    </div>
  );
};

export default PropertyStatusRibbon;
